export default __webpack_public_path__ + "static/media/img_result_line2.fe749eed.svg";